// extracted by mini-css-extract-plugin
export default {"modulePage":"ModulePage_modulePage__Gl0Rj","moduleHeader":"ModulePage_moduleHeader__0Jea7"};